type Listener = () => void;

let isNotFound = false;

const listeners = new Set<Listener>();

export const notFoundStore = {
  getSnapshot: (): boolean => isNotFound,

  subscribe: (listener: Listener) => {
    listeners.add(listener);

    return () => {
      listeners.delete(listener);
    };
  },

  setNotFound: (value: boolean) => {
    if (isNotFound === value) {
      return;
    }

    isNotFound = value;

    listeners.forEach((listener) => {
      listener();
    });
  },
};
